<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>權限設定</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li>
						<router-link to="/index"> <i class="fa fa-home"></i> </router-link>
					</li>
					<li>
						權限設定
					</li>
				</ol>
			</div>
		</header>
		<div class="row">
			<div class="col-md-12">
				<section class="panel">
					<div class="panel-heading">
						<h3 class="panel-title">權限編輯</h3>
						<div class="panel-actions">
							<a href="#addAuth" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
						</div>
					</div>
					<div id="addAuth" class="panel-collapse">
						<div class="panel-body">
							<div class="row form-group" >
								<div class="col-md-6">
									<label class="col-md-3">工(學)號：</label>
									<div class="col-md-6">
										<input type="text" id="account" name="account" class="form-control" value="" v-model="account" />
									</div>
									<div class="col-md-3">
										<a class="btn btn-block" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;" @click="searchUserData()">查詢</a>
									</div>
								</div>
								<div class="col-md-6">
									<label class="col-md-3">單位名稱：</label>
									<div class="col-md-6">
										<select id="" name="" class="form-control" v-model="unitId" @change="deptChange($event)">
											<option value="">--請選擇--</option>
											<option v-for="(dept, key) in deptList" :key="key" :value="dept.unitId">{{dept.unitStr}}</option>
										</select>
									</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-6">
									<label class="col-md-3">姓　　名：</label>
									<div class="col-md-6">{{userData.name}}</div>
								</div>
								<div class="col-md-6">
									<label class="col-md-3">職　　稱：</label>
									<div class="col-md-6">{{userData.accountTypeStr}}</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-6">
									<label class="col-md-3">角　　色：</label>
									<div class="col-md-6">{{userData.titleName}}</div>
								</div>
								<div class="col-md-6">
									<label class="col-md-3">身　　份：</label>
									<div class="col-md-6">{{titleStr}}</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-12">
									<label class="col-md-2 column-required">系統管理：</label>
									<div class="col-md-10">
										<label v-for="(item, index) in menuList.root.nodes" :key="index" class="col-md-3">
											<input type="checkbox" name="" :value="item.id" v-model="funcList" />{{item.title}}
										</label>
									</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-12">
									<label class="col-md-2 column-required">權限設定：</label>
									<div class="col-md-12">
										<ul>
											<li v-for="(item, index) in menuList.root.nodes" :key="index">
												<label>
													<input :id="item.id" type="checkbox" :value="item.id" v-model="selectionItem['root']" @change="handleMenu($event, item.parentId, item.id)"/>
													<i v-if="item.id in menuList" class="glyphicon glyphicon-folder-open"></i>
													<i v-else class="glyphicon glyphicon-link"></i>
													{{item.title}}
												</label>
												<ul v-if="item.id in menuList">
													<li v-for="(item1, index1) in menuList[item.id].nodes" :key="index1">
														<label>
															<input :id="item1.id" type="checkbox" :value="item1.id"  v-model="selectionItem[item.id]" @change="handleMenu($event, item1.parentId, item1.id)"/>
															<i v-if="item1.id in menuList" class="glyphicon glyphicon-folder-open"></i>
															<i v-else class="glyphicon glyphicon-link"></i>
															{{item1.title}}
														</label>
														<ul v-if="item1.id in menuList">
															<li v-for="(item2, index2) in menuList[item1.id].nodes" :key="index2">
																<label>
																	<input :id="item2.id" type="checkbox" :value="item2.id"  v-model="selectionItem[item1.id]" @change="handleMenu($event, item2.parentId, item2.id)"/>
																	<i v-if="item2.id in menuList" class="glyphicon glyphicon-folder-open"></i>
																	<i v-else class="glyphicon glyphicon-link"></i>
																	{{item2.title}}
																</label>
															</li>
														</ul>
													</li>
												</ul>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<p></p>
							<div class="row">
								<div class="col-md-offset-4 col-md-2">
									<button type="button" class="btn btn-default btn-block" @click="cancel()">取消</button>
								</div>
								<div class="col-md-2">
									<button type="button" class="btn btn-primary btn-block" @click="editUserAuth()">儲存</button>
								</div>
								
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</section>
</template>
<script>
import defMeun from '@/json/menu.json';
export default {
	data() {
		return {
			menuList:defMeun,
			menuDefList:"",
			accountType:"",
			account:"",
			unitId:"",
			titleStr:"",
			funcList:[],
			selectionItem:{},
			userData:{},
			deptList:[],
			menus:[]
		};
	},
	created(){
		this.selectionItem = this.selectionInit;
	},
	mounted(){
		this.menuDefList = JSON.stringify(defMeun);
	},
	methods: {
		searchUserData(){
			const api = "/api/Auth/authUser";
			this.$axios.post(api, JSON.stringify({account:this.account})).then(resp=>{
				this.selectionItem=this.selectionInit;
				this.funcList = [];
				this.userData = resp.data.data.userData;
				this.deptList = resp.data.data.userDeptList;
				this.menus = resp.data.data.menus;
				this.buildUserMenu();

			});
		},
		deptChange(event){
			let unitId = event.target.value;
			let tmp = this.deptList.filter(item => {
				return item.unitId == unitId;
			});
			if(tmp.length > 0){
				this.titleStr = tmp[0].unitStr;
			}
			let tmpMeuns = this.menus.filter(item => {
				return item.unitId == unitId
			});
			if(tmpMeuns.length > 0){
					if(tmpMeuns[0].menuJson){
					let menuObj = JSON.parse(tmpMeuns[0].menuJson);
					if(menuObj){
						// 合併 selectionInit，確保所有容器節點都有陣列（避免 Vue2 的 checkbox v-model 退回 boolean 模式）
						this.selectionItem = Object.assign(this.selectionInit, menuObj);
					}
				}
				if(tmpMeuns[0].funcAdmin){
					let funcObj = JSON.parse(tmpMeuns[0].funcAdmin);
					if(funcObj){
						this.funcList = funcObj;
					}
				}
			}
		},
		handleMenu(event, key, id, parentId){
			if(event.target.checked){
				this.appendItem(key, id);
			}else{
				this.removeItem(key, id);
			}
		},
		appendItem(pKey, id, pId){
			// console.log(pKey+","+id + ","+pId);
			if((id in this.menuList) && !pId){
				if(!(id in this.selectionItem)){
					this.selectionItem[id] = [];
				}
				this.menuList[id].nodes.forEach(node => {
					if(!this.selectionItem[id].includes(node.id)){
						this.selectionItem[id].push(node.id);
					}
					if(node.id in this.menuList){
						let parentId = this.menuList[node.id].parentId;
						this.appendItem(parentId,node.id);
					}
				});
			}else if(pKey == "root"){
				if(!this.selectionItem[pKey].includes(id)){
					this.selectionItem[pKey].push(id);
				}
			}
			let parentId = this.menuList[pKey].parentId;
			if(parentId){
				if(!this.selectionItem[parentId].includes(pKey)){
					this.selectionItem[parentId].push(pKey);
				}
				if(this.menuList[pKey].parentId){
					this.appendItem(this.menuList[pKey].parentId, parentId, pKey);
				}
				
			}
			
		},
		removeItem(pKey, id, rId){
			// console.log(pKey+","+id+","+rId);
			if(id in this.selectionItem){
				this.selectionItem[id].forEach(node => {
					if(node in this.selectionItem){
						this.removeItem(id, node);
					}
				});
				this.selectionItem[id] = [];
			}
			if(!Array.isArray(this.selectionItem[pKey])){
				return;
			}
			this.selectionItem[pKey] = this.selectionItem[pKey].filter(node =>{
				return node != id;
			});
			if(this.selectionItem[pKey].length == 0){
				let parentId = this.menuList[pKey] && this.menuList[pKey].parentId;
				if(parentId){
					this.removeItem(parentId, pKey);
				}
			}
		},
		editUserAuth(){
			if(!this.unitId){
				bootbox.alert("請選擇單位");
				return false;
			}
			for(let key in this.selectionItem){
				this.selectionItem[key].sort(function(a, b){
					return a.soft - b.soft;
				});
			}
			let param = {
				account:this.account,
				unitId : this.unitId,
				menuJson:JSON.stringify(this.selectionItem),
				funcAdmin:JSON.stringify(this.funcList)
			}
			const api = "/api/Auth/saveUserMenu";
			this.$axios.post(api, JSON.stringify(param)).then(resp => {
				bootbox.alert(resp.data.msg);
				this.searchUserData();
				this.unitId = "";
			});
		},
		syncData(){
			const api = "/api/Index/SyncUserData";
			this.$axios.post(api, JSON.stringify({}))
		},
		buildUserMenu(){
			this.selectionItem.root = ["bulletin", "offSiteLink"];
			this.selectionItem.bulletin=["news", "stayInDuct"];
			this.selectionItem.offSiteLink=["link1"]
			
			if(this.isLogin){
				if(this.userData.accountType == "ADM"){
					this.selectionItem = JSON.parse(this.menuDefList)
				}else if(this.sessionData.accountType == "TCH"){
					for(let key in this.selectionItem){
						if(key in userMenu){
							this.selectionItem[key] = userMenu[key]
						}
					}
				}else if(this.userData.accountType == "STU"){
					this.selectionItem.root.push("stay");
					this.selectionItem.stay = ["list","assignRoom","stayLife"];
					this.selectionItem.stayLife = ["overnight","deduct","borrow"];
					if(this.userData.isRoomMage == "Y"){
						this.selectionItem.stay.push("retreat");
						this.selectionItem.stayLife.push("rollcall");
						this.selectionItem.stayLife.push("violate");
					}
					if(this.userData.isHire == "Y"){
						this.selectionItem.root.push("stipendMage");
						this.selectionItem.stipendMage = ["partTimeMage"];
						this.selectionItem.partTimeMage = ["student"];
					}
				}
			}else{
				this.selectionItem.bulletin.push("stayApply");
			}
		},
		cancel(){
			Object.assign(this.$data, this.$options.data());
			this.selectionItem = this.selectionInit;
		}
	},
	computed:{
		selectionInit(){
			// 初始化所有 menu.json 中的容器節點，確保 v-model 綁定的陣列都存在
			const json = {};
			for (const key in defMeun) {
				json[key] = [];
			}
			return json;
		}
	},
}
</script>
<style>
</style>